import { render, staticRenderFns } from "./AliplayerVOD.vue?vue&type=template&id=ffae2ccc&scoped=true"
import script from "./AliplayerVOD.vue?vue&type=script&lang=js"
export * from "./AliplayerVOD.vue?vue&type=script&lang=js"
import style0 from "./AliplayerVOD.vue?vue&type=style&index=0&id=ffae2ccc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffae2ccc",
  null
  
)

export default component.exports